module.exports = __webpack_public_path__ + "img/imagen_parrafo_5.23853952.png";